import React, { useEffect, useState, useRef } from "react";
import { useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import VendorService from "../services/VendorServices";
import ItemsService from "../services/ItemsServices";
import UomService from "../services/UomService";
import Breadcrumb from "../components/Breadcrumb";
import ProjectService from "../services/ProjectService";
import StorageService from "../services/StorageService";
import StockInService from "../services/StockInService";
import ProjectStoreService from "../services/ProjectStoreService";
import VendorCategoryService from "../services/VendorCategoryService";
import StockInDetailsService from "../services/StockInDetailsService";
import transportersService from "../services/TransporterService";
import StockInfoService from "../services/stockInfoService";
import ProjectItemService from "../services/ProjectItemService";
import VendorStoreService from "../services/VendorStoreService";
import StockIndentService from "../services/stockIndentService";
import { configSettings } from "../config/configSettings";
import Select from "react-select";
import Loading from "../components/loading";
import MessageDialog from "../components/MessageDialog";


export default function AddStockIn() {
  const [isEdit, setIsEdit] = useState(false);
  const [stockItems, setStockItems] = useState([
    { itemCategoryId: "", itemId: "", uomId: "", itemDescription: "", quantity: "", availableQty: "", notes: "" }
  ]);


  const [projects, setProjects] = useState([]);
  const [projectId, setProjectId] = useState("");
  const [vendorCategories, setVendorCategories] = useState([]);
  const [stores, setStores] = useState([]);
  const [vendors, setVendors] = useState([]);
  const [items, setItems] = useState([]);
  const [uoms, setUoms] = useState([]);
  const [transporters, setTransporters] = useState([]);
  const [vendorStores, setVendorStores] = useState([]);
  const [editData, setEditData] = useState(null);

  const [searchText, setSearchText] = useState({});

  const [projectFullData, setProjectFullData] = useState([]);
  const [categories, setCategories] = useState([]);

  const [message, setMessage] = useState("");

  const [msgType, setMsgType] = useState("");

  const [loading, setLoading] = useState(false);
  const [stockInReceiptPreview, setStockInReceiptPreview] = useState(null);
  const [stockInReceiptOld, setStockInReceiptOld] = useState(null);

  const inputRefs = useRef([]);

  const navigate = useNavigate();
  const { id } = useParams();



  const companyId = StorageService.activeCompany().companyId;
  const userId = StorageService.loginData().employeeId;

  const today = (() => {
    const d = new Date();
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  })();

  const {
    register,
    handleSubmit,
    setValue,
    getValues,
    watch,
    trigger,
    formState: { errors },
  } = useForm({
    mode: "onChange",
    reValidateMode: "onChange",
    defaultValues: {
      invoiceDate: today,
      receivedDate: today,
    },
  });

  const invoiceDateValue = watch("invoiceDate");
  const storeIdValue = watch("storeId");

  const selectedStore = stores.find((s) => String(s.storeId) === String(storeIdValue));
  const storeName = selectedStore ? selectedStore.storeName || "" : "";

  const getFilteredCategories = () => {
    return categories;
  };

  const showMessage = (text, type = "error") => {
    setMessage(text);
    setMsgType(type);
  };

  //   try {
  //     let projectsData = [];

  //     // SUPER ADMIN → ALL PROJECTS BY COMPANY
  //     if (
  //       emp.roleName === "Super Admin" ||
  //       emp.roleName === "SuperAdmin" ||
  //       Number(emp.roleId) === 1
  //     ) {
  //       const res = await ProjectService.getActive(comp.companyId);

  //       projectsData = (res || []).map(p => ({
  //         projectId: p.id,
  //         projectName: p.projectName
  //       }));
  //     }
  //     //  NORMAL USER → ASSIGNED PROJECTS
  //     else {
  //       const res = await ProjectService.getAssignedProjects(
  //         comp.companyId,
  //         emp.employeeId
  //       );
  //       console.log("Projects dropdown data:", projects);
  //       projectsData = res?.data?.data || [];
  //     }

  //     setProjects(projectsData);
  //   } catch (err) {
  //     console.error("Error loading projects:", err);
  //     setProjects([]);
  //   }
  // };

  const loadProjects = async () => {
    const emp = StorageService.loginData();
    const comp = StorageService.activeCompany();

    try {
      let projectsData = [];

      // SUPER ADMIN & DATA ADMIN → ALL PROJECTS
      if (
        emp.roleName === "Super Admin" ||
        emp.roleName === "SuperAdmin" ||
        emp.roleName === "Data Admin" ||
        emp.roleName === "DataAdmin" ||
        Number(emp.roleId) === 1 ||
        Number(emp.roleId) === 2
      ) {
        const res = await ProjectService.getActive(comp.companyId);

        projectsData = (res || []).map(p => ({
          projectId: p.id,
          projectName: p.projectName,
          projectCode: p.projectCode   // ✅ ADD THIS
        }));
      }
      // NORMAL USER → ASSIGNED PROJECTS
      else {
        const res = await ProjectService.getAssignedProjects(
          comp.companyId,
          emp.employeeId
        );

        projectsData = (res?.data?.data || []).map(p => ({
          projectId: p.projectId,
          projectName: p.projectName,
          projectCode: p.projectCode   // ✅ ADD THIS
        }));
      }

      setProjects(projectsData);
    } catch (err) {
      console.error("Error loading projects:", err);
      setProjects([]);
    }
  };

  useEffect(() => {
    if (!editData || stores.length === 0) return;

    setValue("storeId", String(editData.storeId));

  }, [stores, editData]);


  useEffect(() => {

    if (!editData || transporters.length === 0) return;

    setValue("vendorCategoryId", String(editData.vendorCategoryId));

    handleVendorCategoryChange(
      String(editData.vendorCategoryId),
      String(editData.vendorId)
    );

    // Load vendor stores for edit mode
    const loadVendorStoresForEdit = async () => {
      try {
        const res = await VendorStoreService.getByVendor(editData.vendorId);
        setVendorStores(res?.data || []);
        setValue("vendorStoreId", String(editData.vendorStoreId));
      } catch (err) {
        console.error("Error loading vendor stores for edit:", err);
      }
    };
    if (editData.vendorId) {
      loadVendorStoresForEdit();
    }

    setValue("voucherNo", editData.voucherNo || editData.vocherNo || "");
    setValue("transporterId", String(editData.transporterId));
    setValue("vehicleNo", editData.vehicleNo);
    setValue("stockInNotes", editData.stockInNotes);
    const rawReceipt = editData.stockInReceipt || null;
    let filename = rawReceipt;
    let previewUrl = null;
    if (rawReceipt) {
      if (rawReceipt.startsWith("http://") || rawReceipt.startsWith("https://")) {
        previewUrl = rawReceipt;
        const parts = rawReceipt.split("/");
        filename = parts[parts.length - 1];
      } else {
        previewUrl = `${configSettings.mediaURL}/get/StockIn/${rawReceipt}`;
      }
    }
    setValue("stockInReceipt", filename || "");
    setStockInReceiptOld(filename);
    setStockInReceiptPreview(previewUrl);
    setValue("invoiceNo", editData.invoiceNo);

    setValue("invoiceDate", formatDate(editData.invoiceDate));
    setValue("receivedDate", formatDate(editData.receivedDate));

  }, [editData, transporters]);

  useEffect(() => {

    if (!editData || !editData.details || projectFullData.length === 0) return;

    const detailsMapped = editData.details.map((d) => {

      let categoryId = "";
      let description = "";

      projectFullData.forEach(cat => {

        const found = cat.items.find(
          i => String(i.itemId) === String(d.itemId)
        );

        if (found) {
          categoryId = cat.itemCategoryId;
          description = found.itemDescription;
        }

      });

      return {
        itemCategoryId: categoryId,
        itemId: String(d.itemId),
        description: description || d.itemCode || "",
        uomId: d.UOM,
        quantity: d.quantity,
        availableQty: 0,
        notes: d.notes || ""
      };

    });

    setStockItems(detailsMapped);

    // load available quantity
    detailsMapped.forEach(async (row, index) => {
      const pId = editData?.projectId || projectId;
      const sId = Number(editData?.storeId);

      if (pId && sId && row.itemId) {
        try {
          const availQty = await fetchAvailableQuantity(pId, sId, Number(row.itemId));
          setStockItems(prev => {
            const updated = [...prev];
            if (updated[index]) {
              updated[index].availableQty = availQty;
            }
            return updated;
          });
        } catch (err) {
          console.error("Stock load error:", err);
        }
      }
    });

  }, [editData, projectFullData]);

  const fetchAvailableQuantity = async (pId, sId, itemId) => {
    const activeCompanyId = StorageService.activeCompany()?.companyId;

    if (!activeCompanyId || !pId || !sId || !itemId) return "0.000";

    try {
      const res = await StockIndentService.getAvailableStock(
        activeCompanyId,
        pId,
        sId,
        itemId
      );

      const qty = res?.data?.result?.quantity ?? 0;
      return formatQty3(qty);
    } catch (err) {
      console.error("Available qty fetch error", err);
      return "0.000";
    }
  };

  const updateAllAvailableQuantities = (pid, sid) => {
    if (!pid || !sid) return;
    stockItems.forEach(async (row, index) => {
      if (row.itemId) {
        const availQty = await fetchAvailableQuantity(pid, sid, Number(row.itemId));
        setStockItems((prev) => {
          const copy = [...prev];
          if (copy[index]) copy[index].availableQty = availQty;
          return copy;
        });
      }
    });
  };


  // ✅ LOAD ITEMS BY PROJECT
  const loadItemsByProject = async (pId) => {
    try {
      const res = await ProjectItemService.getByProjectId(pId);

      const list = res?.data?.data || [];

      // Normalize for dropdown usage
      const mappedItems = list.map((x) => ({
        id: x.itemId,
        itemId: x.itemId,
        itemName: x.itemCode,            // shown in dropdown
        itemDescription: x.itemDescription,
        uomName: x.uomName || x.uom,
      }));

      setItems(mappedItems);
    } catch (err) {
      console.error("Project items load error:", err);
      setItems([]);
    }
  };


  // --- LOAD STORES for a project ---
  const loadStores = async (pId) => {
    try {
      const res = await ProjectStoreService.getProjectStoreById(pId);
      const list = res.data || res || [];
      const filtered = list.filter((s) => String(s.projectId) === String(pId));
      setStores(filtered);
    } catch (err) {
      console.error("Store load error:", err);
      setStores([]);
    }
  };

  // --- LOAD ITEMS (same as reference: getAllItems) ---
  const loadItems = async () => {
    try {
      const res = await ItemsService.getAllItems();
      setItems(res.data || res || []);
    } catch (err) {
      console.error("Items load error:", err);
      setItems([]);
    }
  };

  const loadTransporters = async () => {
    try {
      // dropdown → always first page
      const res = await transportersService.getActiveTransporters(1, 100);

      // normalize response
      const list = res?.data || [];

      setTransporters(list);
    } catch (err) {
      console.error("Transporter load error:", err);
      setTransporters([]);
    }
  };



  // initial load: projects, vendor categories, items (reference does items load on init)
  useEffect(() => {
    loadProjects();
    loadTransporters();

    VendorCategoryService.getActive()
      .then((res) => setVendorCategories(res.data || res || []))
      .catch(() => setVendorCategories([]));

    // ✅ DO NOT load items here

    UomService.getAll()
      .then((res) => setUoms(res.data || res || []))
      .catch(() => setUoms([]));
  }, []);

  // Auto-select dropdowns if only 1 option is available
  useEffect(() => {
    if (projects.length === 1 && !isEdit) {
      const singleProj = projects[0];
      const pId = String(singleProj.projectId ?? singleProj.id);
      setValue("projectId", pId);
      setProjectId(pId);
    }
  }, [projects, isEdit]);

  useEffect(() => {
    const filteredStores = stores.filter((s) => {
      const name = (s.storeName || s.name || "").trim().toLowerCase();
      return !name.startsWith("scrap") && !name.startsWith("s");
    });
    if (filteredStores.length === 1 && !isEdit) {
      const singleStore = filteredStores[0];
      const sId = String(singleStore.storeId ?? singleStore.id);
      setValue("storeId", sId);
      const pId = getValues("projectId") || projectId;
      if (pId && sId) {
        fetchVoucherNo(pId, sId);
      }
    }
  }, [stores, isEdit, projectId]);

  useEffect(() => {
    if (vendorCategories.length === 1 && !isEdit) {
      const singleCat = vendorCategories[0];
      const catId = String(singleCat.id ?? singleCat.vendorCategoryId);
      setValue("vendorCategoryId", catId);
      handleVendorCategoryChange(catId);
    }
  }, [vendorCategories, isEdit]);

  useEffect(() => {
    if (vendors.length === 1 && !isEdit) {
      const singleVendor = vendors[0];
      const vId = String(singleVendor.id);
      setValue("vendorId", vId);
      handleVendorChange(vId);
    }
  }, [vendors, isEdit]);

  useEffect(() => {
    if (isEdit && editData && vendorStores.length > 0) {
      setValue("vendorStoreId", String(editData.vendorStoreId));
    } else if (vendorStores.length === 1 && !isEdit) {
      const singleStore = vendorStores[0];
      const vsId = String(singleStore.id);
      setValue("vendorStoreId", vsId);
    }
  }, [vendorStores, isEdit, editData, setValue]);

  useEffect(() => {
    if (transporters.length === 1 && !isEdit) {
      const singleTrans = transporters[0];
      const tId = String(singleTrans.id ?? singleTrans.transporterId);
      setValue("transporterId", tId);
    }
  }, [transporters, isEdit]);

  useEffect(() => {
    if (!id) {
      const d = new Date();
      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, "0");
      const day = String(d.getDate()).padStart(2, "0");
      const todayString = `${year}-${month}-${day}`;
      setValue("invoiceDate", todayString);
      setValue("receivedDate", todayString);
    }
  }, [id, setValue]);

  const fetchVoucherNo = async (pId, sId) => {
    if (!pId || !sId) {
      setValue("voucherNo", "");
      return;
    }

    if (isEdit && editData && String(editData.storeId) === String(sId) && String(editData.projectId) === String(pId)) {
      setValue("voucherNo", editData.voucherNo || editData.vocherNo || "");
      return;
    }

    try {
      const res = await StockInService.previewVoucherNo(pId, sId);
      setValue("voucherNo", res?.data?.voucherNo || "");
    } catch (err) {
      console.error("StockIn voucher fetch error", err);
      setValue("voucherNo", "");
    }
  };


  // when projectId changes -> load stores and items (reference triggers both stores and items)
  useEffect(() => {
    if (!projectId) {
      setStores([]);
      setItems([]);
      return;
    }

    loadStores(projectId);
    loadProjectFullData(projectId);
    loadItemsByProject(projectId);
  }, [projectId]);


  // handle vendor category -> vendors (unchanged logic, preserved)
  const handleVendorCategoryChange = async (categoryId, vendorToSelect = null) => {
    setVendors([]);
    if (!categoryId) {
      setValue("vendorId", "");
      return;
    }

    try {
      const res = await VendorService.getByCategory(categoryId);
      const list = res.data || res || [];
      // const filtered = list.filter(
      //   (v) => String(v.vendorCategoryId) === String(categoryId)
      // );
      setVendors(list);

      if (vendorToSelect) {
        setTimeout(() => {
          setValue("vendorId", String(vendorToSelect));
        }, 50);
      } else {
        setValue("vendorId", "");
      }
    } catch (err) {
      console.error("Vendor load error:", err);
      setVendors([]);
      setValue("vendorId", "");
    }
  };

  const handleVendorChange = async (vendorId) => {
    setValue("vendorStoreId", "");
    setVendorStores([]);

    if (!vendorId) {
      return;
    }

    try {
      const res = await VendorStoreService.getByVendor(vendorId);
      setVendorStores(res?.data || []);
    } catch (err) {
      console.error("Error loading vendor stores:", err);
      setVendorStores([]);
    }

    const selectedVendor = vendors.find((v) => String(v.id) === String(vendorId));
    if (selectedVendor) {
      const matchingTransporter = transporters.find((t) =>
        (t.transporterCode && selectedVendor.vendorCode && String(t.transporterCode).trim().toLowerCase() === String(selectedVendor.vendorCode).trim().toLowerCase()) ||
        (t.transporterName && selectedVendor.vendorName && String(t.transporterName).trim().toLowerCase() === String(selectedVendor.vendorName).trim().toLowerCase())
      );
      if (matchingTransporter) {
        setValue("transporterId", String(matchingTransporter.id));
      } else {
        setValue("transporterId", "");
      }
    }
  };

  const loadProjectFullData = async (pId) => {
    try {
      const res = await ProjectItemService.getProjectFullData(pId);
      const data = res?.data?.data || [];
      setProjectFullData(data);
      setCategories(data);
    } catch (err) {
      console.error(err);
      setProjectFullData([]);
      setCategories([]);
    }
  };


  const handleCategoryChange = (index, categoryId) => {
    const updated = [...stockItems];
    updated[index].itemCategoryId = categoryId;
    updated[index].itemId = "";
    updated[index].itemDescription = "";
    updated[index].uomId = "";
    updated[index].availableQty = "";
    setStockItems(updated);
  };


  // const formatDateTimeLocal = (isoString) => {
  //   if (!isoString) return "";
  //   const d = new Date(isoString);
  //   return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(
  //     2,
  //     "0"
  //   )}-${String(d.getDate()).padStart(2, "0")}T${String(d.getHours()).padStart(
  //     2,
  //     "0"
  //   )}:${String(d.getMinutes()).padStart(2, "0")}`;
  // };

  const formatDate = (iso) => {
    if (!iso) return "";
    return iso.split("T")[0];
  };

  const formatQty3 = (val) => {
    if (val === null || val === undefined || val === "") return "0.000";
    return Number(val).toFixed(3);
  };

  useEffect(() => {
    if (!id) return;

    setIsEdit(true);

    const loadEdit = async () => {
      setLoading(true);
      try {
        const res = await StockInService.getById(id);
        const data = res?.data?.data;

        if (!data) return;

        setProjectId(String(data.projectId));

        setValue("projectId", String(data.projectId));
        setEditData(data);
        // setTimeout(() => {
        //   setValue("storeId", String(data.storeId));
        //   setValue("vendorCategoryId", String(data.vendorCategoryId));
        //   handleVendorCategoryChange(
        //     String(data.vendorCategoryId),
        //     String(data.vendorId)
        //   );
        //   setValue("transporterId", String(data.transporterId));
        //   setValue("vehicleNo", data.vehicleNo);
        //   setValue("stockInNotes", data.stockInNotes);
        //   setValue("invoiceNo", data.invoiceNo);
        //   // setValue("invoiceDate", formatDateTimeLocal(data.invoiceDate));
        //   // setValue("receivedDate", formatDateTimeLocal(data.receivedDate));
        //   setValue("invoiceDate", formatDate(data.invoiceDate));
        //   setValue("receivedDate", formatDate(data.receivedDate));

        //   // if (Array.isArray(data.details)) {

        //   //   const detailsMapped = data.details.map((d) => {

        //   //     // find item from project items list
        //   //     const matched = items.find(
        //   //       (it) =>
        //   //         String(it.id) === String(d.itemId) ||
        //   //         String(it.itemId) === String(d.itemId)
        //   //     );

        //   //     return {
        //   //       itemCategoryId: "", // category will auto match from projectFullData
        //   //       itemId: String(d.itemId),
        //   //       description: matched?.itemDescription || d.itemCode || "",
        //   //       uomId: d.UOM || matched?.uomName || "",
        //   //       quantity: d.quantity,
        //   //       availableQty: 0
        //   //     };
        //   //   });

        //   //   setStockItems(detailsMapped);
        //   // }
        //   if (Array.isArray(data.details)) {

        //     const detailsMapped = data.details.map((d) => {

        //       let categoryId = "";
        //       let description = "";

        //       // 🔎 find category from projectFullData
        //       projectFullData.forEach(cat => {
        //         const found = cat.items.find(i => String(i.itemId) === String(d.itemId));

        //         if (found) {
        //           categoryId = cat.itemCategoryId;
        //           description = found.itemDescription;
        //         }
        //       });

        //       return {
        //         itemCategoryId: categoryId,
        //         itemId: String(d.itemId),
        //         description: description || d.itemCode,
        //         uomId: d.UOM,
        //         quantity: d.quantity,
        //         availableQty: 0
        //       };
        //     });

        //     setStockItems(detailsMapped);

        //     // 🔥 load available quantity
        //     detailsMapped.forEach(async (row, index) => {

        //       const storeId = Number(data.storeId);

        //       if (storeId && row.itemId) {

        //         try {

        //           const res = await StockInfoService.getItemStockDetails(
        //             storeId,
        //             Number(row.itemId)
        //           );

        //           const stockResult = res?.result || res?.data?.result;

        //           setStockItems(prev => {
        //             const updated = [...prev];
        //             updated[index].availableQty = Number(stockResult?.quantity ?? 0);
        //             return updated;
        //           });

        //         } catch (err) {
        //           console.error("Stock load error:", err);
        //         }

        //       }

        //     });

        //   }
        // }, 300);
      } catch (err) {
        console.log("EDIT LOAD ERROR:", err);
      } finally {
        setLoading(false);
      }
    };

    loadEdit();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const hasDuplicateItems = () => {
    const selectedItemIds = stockItems
      .map((row) => String(row.itemId).trim())
      .filter((itemId) => itemId);

    return selectedItemIds.length !== new Set(selectedItemIds).size;
  };

  const handleAddRow = () => {
    if (hasDuplicateItems()) {
      showMessage("Please remove duplicate items before adding a new row.", "error");
      return;
    }

    setStockItems([
      ...stockItems,
      { itemCategoryId: "", itemId: "", uomId: "", itemDescription: "", quantity: "", availableQty: "", notes: "" }
    ]);
  };


  const handleDeleteRow = (i) => {
    const upd = [...stockItems];
    upd.splice(i, 1);
    setStockItems(upd);
  };

  // const handleChange = async (i, field, value) => {
  //   const upd = [...stockItems];
  //   upd[i][field] = value;

  //   if (field === "itemId") {
  //     const selectedItem =
  //       items.find((it) => String(it.id) === String(value)) ||
  //       items.find((it) => String(it.itemId) === String(value));

  //     // ✅ ALWAYS set from item master first
  //     upd[i].description = selectedItem?.itemDescription || "";
  //     upd[i].uomId = selectedItem?.uomName || "";   // 🔥 FIX
  //     upd[i].availableQty = "";

  //     const storeId = Number(getValues("storeId"));

  //     // ✅ THEN override from stock API (if available)
  //     if (storeId && value) {
  //       try {
  //         const res = await StockInfoService.getItemStockDetails(
  //           storeId,
  //           Number(value)
  //         );

  //         const stockResult = res?.result || res?.data?.result;

  //         upd[i].availableQty = Number(stockResult?.quantity ?? 0);
  // updated[index].availableQty = formatQty3(stockResult?.quantity);
  //         // override UOM only if API sends it
  //         if (stockResult?.uom) {
  //           upd[i].uomId = stockResult.uom;
  //         }
  //       } catch (err) {
  //         console.error("Stock info load error:", err);
  //       }
  //     }
  //   }

  //   setStockItems(upd);
  // };

  const handleChange = async (i, field, value) => {
    if (
      field === "itemId" &&
      value &&
      stockItems.some(
        (row, rowIndex) => rowIndex !== i && String(row.itemId) === String(value)
      )
    ) {
      showMessage("This item is already selected in another row.", "error");
      return;
    }

    const upd = [...stockItems];
    upd[i][field] = value;

    if (field === "itemId") {

      // 🔥 TAKE MASTER DATA FROM OLD ITEMS LIST
      const selectedItem =
        items.find((it) => String(it.id) === String(value)) ||
        items.find((it) => String(it.itemId) === String(value));

      // ✅ description from master
      upd[i].description = selectedItem?.itemDescription || "";

      // ✅ UOM from master
      upd[i].uomId = selectedItem?.uomName || "";

      // reset qty
      upd[i].availableQty = "0.000";
      const pId = getValues("projectId") || projectId;
      const sId = Number(getValues("storeId"));

      // ✅ STOCK API override (scoped to company + project + store + item)
      if (pId && sId && value) {
        try {
          const availQty = await fetchAvailableQuantity(pId, sId, Number(value));
          upd[i].availableQty = availQty;
        } catch (err) {
          console.error("Stock info load error:", err);
        }
      }
    }

    setStockItems(upd);
  };


  const handleQuantityChange = (index, e) => {
    let value = e.target.value;

    // allow only numbers + decimal with at most 3 decimal places
    if (value !== "" && !/^\d*\.?\d{0,3}$/.test(value)) return;

    setStockItems(prev => {
      const updated = [...prev];
      updated[index] = {
        ...updated[index],
        quantity: value
      };
      return updated;
    });
  };

  const handleQuantityBlur = (index) => {
    setStockItems(prev => {
      const updated = [...prev];
      const val = updated[index].quantity;
      if (val !== "" && !isNaN(Number(val))) {
        updated[index].quantity = Number(val).toFixed(3);
      }
      return updated;
    });
  };


  const handleStockInReceiptUpload = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      setStockInReceiptPreview(reader.result);
      setValue("stockInReceipt", reader.result);
    };
  };

  const onSubmit = async (data) => {
    setLoading(true);

    if (hasDuplicateItems()) {
      showMessage("Duplicate items are not allowed in stock in details.", "error");
      setLoading(false);
      return;
    }

    try {
      const detailsPayload = stockItems.map((x) => ({
        itemId: Number(x.itemId),
        UOM: x.uomId,
        quantity: Number(x.quantity),
        notes: x.notes || "",
        createdBy: userId,
        createdDate: new Date().toISOString(),
      }));

      const payload = {
        companyId,
        storeId: Number(data.storeId),
        vendorCategoryId: Number(data.vendorCategoryId),
        vendorId: Number(data.vendorId),
        vendorStoreId: Number(data.vendorStoreId),
        transporterId: Number(data.transporterId),
        vehicleNo: data.vehicleNo?.trim(),
        stockInNotes: data.stockInNotes,
        stockInReceipt: (stockInReceiptPreview && stockInReceiptPreview.startsWith("data:"))
          ? stockInReceiptPreview
          : (stockInReceiptOld || ""),
        invoiceNo: data.invoiceNo,
        invoiceDate: data.invoiceDate,
        receivedDate: data.receivedDate,
        projectId: Number(projectId),
        roleId: Number(StorageService.loginData()?.roleId),
        vocherNo: data.voucherNo,
        createdBy: userId,
        createdDate: new Date().toISOString(),
        stockInDetails: detailsPayload,
      };

      if (isEdit) {
        await StockInService.update(id, payload);
        showMessage("StockIn updated successfully!", "success");
      } else {
        await StockInService.save(payload);
        showMessage("StockIn added successfully!", "success");
      }

      setTimeout(() => navigate("/cpnl/stockin/view"), 1500);
    } catch (err) {
      console.error("SAVE ERROR:", err);

      // ✅ Show backend validation message
      const backendMessage =
        err?.response?.data?.message ||
        err?.response?.data?.false ||
        "Error saving StockIn";

      showMessage(backendMessage, "error");
    } finally {
      setLoading(false);
    }
  };



  // const onSubmit = async (data) => {
  //   setLoading(true);

  //   try {
  //     const detailsPayload = stockItems.map((x) => ({
  //       itemId: Number(x.itemId),
  //       UOM: x.uomId,
  //       quantity: Number(x.quantity),
  //       status: "active",
  //       createdBy: userId,
  //       createdDate: new Date().toISOString(),
  //     }));

  //     const payload = {
  //       companyId,
  //       storeId: Number(data.storeId),
  //       vendorCategoryId: Number(data.vendorCategoryId),
  //       vendorId: Number(data.vendorId),
  //       transporterId: Number(data.transporterId),
  //       stockInNotes: data.stockInNotes,
  //       invoiceNo: data.invoiceNo,
  //       invoiceDate: data.invoiceDate,
  //       projectId: Number(projectId),
  //       status: "active",
  //       createdBy: userId,
  //       createdDate: new Date().toISOString(),
  //       stockInDetails: detailsPayload,
  //     };

  //     let response;

  //     if (isEdit) {
  //       response = await StockInService.update(id, payload);
  //       showMessage("StockIn updated successfully", "success");
  //     } else {
  //       response = await StockInService.save(payload);
  //       showMessage("StockIn added successfully", "success");
  //     }

  //     setTimeout(() => navigate("/cpnl/stockin/view"), 1500);
  //   } catch (err) {
  //     console.error("SAVE ERROR:", err);
  //     showMessage("Error saving StockIn", "error");
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const getItemOptions = (categoryId) => {
    const cat = projectFullData.find(
      (c) => String(c.itemCategoryId) === String(categoryId)
    );

    if (!cat) return [];

    return cat.items.map((i) => ({
      value: i.itemId,
      label: i.itemCode,
    }));
  };


  const handleCancel = () => {
    // showMessage("Action cancelled.", "error");
    setTimeout(() => navigate("/cpnl/stockin/view"), 600);
  };

  if (loading) {
    return <Loading />;
  }

  return (
    <>
      <Breadcrumb
        pageTitle={isEdit ? "Modify StockIn" : "Add StockIn"}
        secondTitle="Inventory"
      />
      <div className="card p-4 bg-white shadow-sm">
        {/* {message && (
          <div
            className={`alert ${msgType === "success" ? "alert-success" : "alert-danger"
              } d-flex justify-content-between align-items-center w-100 mb-3 p-2`}
          >
            <span>{message}</span>
            <button
              type="button"
              className="btn-close"
              onClick={closeMessage}
            ></button>
          </div>
        )} */}

        <MessageDialog
          message={message}
          type={msgType}
          setMessage={setMessage}
          setMsgType={setMsgType}
        />

        <form onSubmit={handleSubmit(onSubmit)} noValidate>
          <div className="row">
            <div className="mb-3 col-md-4">
              <label className="form-label">Project <span className="text-danger">*</span></label>
              <select
                className="form-select"
                {...register("projectId", { required: "Project is required" })}
                onChange={(e) => {
                  const pid = e.target.value;
                  setProjectId(pid);
                  setValue("projectId", pid);
                  setValue("storeId", "");
                  setValue("voucherNo", "");
                  setStores([]);
                  setStockItems([
                    { itemCategoryId: "", itemId: "", uomId: "", itemDescription: "", quantity: "", availableQty: "", notes: "" }
                  ]);
                  loadStores(pid);
                  loadProjectFullData(pid);
                  loadItemsByProject(pid);
                }}
              >
                <option value="">Select Project</option>
                {projects.map((p) => (
                  <option key={p.projectId} value={p.projectId}>
                    {p.projectCategoryName ? `${String(p.projectCategoryName).trim().charAt(0).toUpperCase()}*${p.projectName}` : (p.projectCode ? `${String(p.projectCode).trim().charAt(0).toUpperCase()}*${p.projectName}` : p.projectName)}
                  </option>
                ))}
              </select>
            </div>

            <div className="mb-3 col-md-4">
              <label className="form-label">
                Store <span className="text-danger">*</span>
              </label>
              <select
                className="form-select"
                {...register("storeId", {
                  required: "Store is required",
                  onChange: (e) => {
                    const sid = e.target.value;
                    setValue("storeId", sid);
                    const pid = getValues("projectId") || projectId;
                    if (pid && sid) {
                      fetchVoucherNo(pid, sid);
                      updateAllAvailableQuantities(pid, sid);
                    } else {
                      setValue("voucherNo", "");
                    }
                  }
                })}
              >
                <option value="">Select Store</option>
                {stores.map((s) => (
                  <option key={s.storeId} value={s.storeId}>
                    {s.storeName}
                  </option>
                ))}
              </select>
              {errors.storeId && (
                <small className="text-danger">{errors.storeId.message}</small>
              )}
            </div>

            <div className="mb-3 col-md-4">
              <label className="form-label">Voucher No</label>
              <input
                type="text"
                className="form-control"
                {...register("voucherNo")}
                readOnly
              />
            </div>
          </div>

          <div className="row">
            <div className="mb-3 col-md-4">
              <label className="form-label">Vendor Category <span className="text-danger">*</span></label>
              <select
                className="form-select"
                {...register("vendorCategoryId", {
                  required: "Vendor Category is required",
                })}
                onChange={(e) => handleVendorCategoryChange(e.target.value)}
              >
                <option value="">Select Category</option>
                {vendorCategories.map((c) => (
                  <option
                    key={c.id ?? c.vendorCategoryId}
                    value={c.id ?? c.vendorCategoryId}
                  >
                    {c.vendorCategoryName || c.categoryName || c.name}
                  </option>
                ))}
              </select>
            </div>

            <div className="mb-3 col-md-4">
              <label className="form-label">
                Vendor <span className="text-danger">*</span>
              </label>
              <select
                className="form-select"
                {...register("vendorId", {
                  required: "Vendor is required",
                  onChange: (e) => handleVendorChange(e.target.value)
                })}
              >
                <option value="">Select Vendor</option>
                {vendors.map((v) => (
                  <option key={v.id} value={v.id}>
                    {v.vendorName}
                  </option>
                ))}
              </select>
              {errors.vendorId && (
                <small className="text-danger">{errors.vendorId.message}</small>
              )}
            </div>

            {/* Vendor Location */}
            <div className="mb-3 col-md-4">
              <label className="form-label">
                Vendor Location <span className="text-danger">*</span>
              </label>
              <select
                className="form-select"
                {...register("vendorStoreId", { required: "Vendor Location is required" })}
              >
                <option value="">Select Location</option>
                {vendorStores.map((vs) => (
                  <option key={vs.id} value={vs.id}>
                    {vs.vendorStoreName}
                  </option>
                ))}
              </select>
              {errors.vendorStoreId && (
                <small className="text-danger">{errors.vendorStoreId.message}</small>
              )}
            </div>
          </div>

          <div className="row">
            {/* Transporter */}
            <div className="mb-3 col-md-4">
              <label className="form-label">
                Transporter <span className="text-danger">*</span>
              </label>
              <select
                className="form-select"
                {...register("transporterId", { required: "Transporter is required" })}
              >
                <option value="">Select Transporter</option>
                {transporters.map((t) => (
                  <option
                    key={t.id ?? t.transporterId}
                    value={t.id ?? t.transporterId}
                  >
                    {t.transporterName || t.name}
                  </option>
                ))}
              </select>
              {errors.transporterId && (
                <small className="text-danger">{errors.transporterId.message}</small>
              )}
            </div>

            {/* Vehicle Number */}
            <div className="col-md-4 mb-3">
              <label className="form-label">
                Vehicle No <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className={`form-control ${errors.vehicleNo ? "is-invalid" : ""}`}
                placeholder="Example: TS09AB1234"
                {...register("vehicleNo", {
                  required: "Vehicle No is required",
                })}
                onChange={(e) => {
                  const value = e.target.value
                    .toUpperCase()
                    .replace(/[^A-Z0-9]/g, ""); // remove spaces & symbols

                  e.target.value = value;
                }}
              />
              {errors.vehicleNo && (
                <small className="text-danger">
                  {errors.vehicleNo.message}
                </small>
              )}
            </div>

            {/* Invoice Number */}
            <div className="mb-3 col-md-4">
              <label className="form-label">
                Customer Invoice No <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className={`form-control ${errors.invoiceNo ? "is-invalid" : ""}`}
                placeholder="Invoice No"
                {...register("invoiceNo", {
                  required: "Customer Invoice No is required",
                  validate: () => true,
                })}
                onChange={(e) => {
                  let value = e.target.value
                    .toUpperCase()
                    .replace(/[^A-Z0-9\-\/]/g, ""); // allow - and /

                  e.target.value = value;
                }}
              />
              {errors.invoiceNo && (
                <small className="text-danger">
                  {errors.invoiceNo.message}
                </small>
              )}
            </div>
          </div>

          <div className="row">
            {/* Invoice Date */}
            <div className="mb-3 col-md-4">
              <label className="form-label">
                Invoice Date <span className="text-danger">*</span>
              </label>
              <input
                type="date"
                className="form-control"
                {...register("invoiceDate", {
                  required: "Invoice Date is required",
                  onChange: () => trigger("receivedDate"),
                  validate: (value) => {
                    if (!value) return true;

                    const emp = StorageService.loginData();
                    const isPrivileged =
                      emp?.roleName === "Super Admin" ||
                      emp?.roleName === "SuperAdmin" ||
                      emp?.roleName === "Data Admin" ||
                      emp?.roleName === "DataAdmin" ||
                      Number(emp?.roleId) === 1 ||
                      Number(emp?.roleId) === 2;

                    if (!isPrivileged) {
                      const todayStr = new Date().toLocaleDateString("en-CA");
                      if (value < todayStr) {
                        return "Only Super Admin and Data Admin can select a past date";
                      }
                    }

                    return true;
                  }
                })}
              />
              {errors.invoiceDate && (
                <small className="text-danger">
                  {errors.invoiceDate.message}
                </small>
              )}
            </div>

            {/* Received Date */}
            <div className="mb-3 col-md-4">
              <label className="form-label">Received Date</label>
              <input
                type="date"
                className="form-control"
                min={invoiceDateValue || undefined}
                {...register("receivedDate", {
                  validate: (value) => {
                    const invoiceDate = getValues("invoiceDate");

                    if (!value || !invoiceDate) return true;

                    if (value < invoiceDate) {
                      return "Received Date should not be less than Invoice Date";
                    }

                    const emp = StorageService.loginData();
                    const isPrivileged =
                      emp?.roleName === "Super Admin" ||
                      emp?.roleName === "SuperAdmin" ||
                      emp?.roleName === "Data Admin" ||
                      emp?.roleName === "DataAdmin" ||
                      Number(emp?.roleId) === 1 ||
                      Number(emp?.roleId) === 2;

                    if (!isPrivileged) {
                      const todayStr = new Date().toLocaleDateString("en-CA");
                      if (value < todayStr) {
                        return "Only Super Admin and Data Admin can select a past date";
                      }
                    }

                    return true;
                  },
                })}
              />
              {errors.receivedDate && (
                <small className="text-danger">
                  {errors.receivedDate.message}
                </small>
              )}
            </div>

            {/* Notes */}
            <div className="col-md-4 mb-3">
              <label className="form-label">Notes</label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter notes"
                {...register("stockInNotes")}
              />
            </div>

            {/* Receipt Upload */}
            <div className="col-md-4 mb-3">
              <label className="form-label">Receipt Upload</label>
              <input
                type="file"
                className="form-control form-control-sm"
                accept="image/*,.pdf"
                onChange={handleStockInReceiptUpload}
              />
              {(stockInReceiptPreview || stockInReceiptOld) && (
                <div className="d-flex align-items-center gap-2 mt-1">
                  {(stockInReceiptPreview?.startsWith("data:image/") || (stockInReceiptOld && /\.(jpg|jpeg|png|gif|webp|bmp)$/i.test(stockInReceiptOld))) ? (
                    <a
                      href={stockInReceiptPreview}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img
                        src={stockInReceiptPreview}
                        alt="stock-in receipt"
                        width="40"
                        height="30"
                        style={{ objectFit: "cover", borderRadius: "4px", cursor: "pointer" }}
                      />
                    </a>
                  ) : (
                    <a
                      href={stockInReceiptPreview || (stockInReceiptOld ? `${configSettings.mediaURL}/get/StockIn/${stockInReceiptOld}` : "#")}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="badge bg-info text-decoration-none"
                      style={{ cursor: "pointer" }}
                    >
                      View File
                    </a>
                  )}
                  <button
                    type="button"
                    className="btn btn-sm btn-outline-danger py-0 px-1"
                    style={{ fontSize: "10px" }}
                    onClick={() => {
                      setStockInReceiptPreview(null);
                      setStockInReceiptOld(null);
                      setValue("stockInReceipt", "");
                    }}
                  >
                    Remove
                  </button>
                </div>
              )}
            </div>
          </div>


          <hr />
          <h5>Stock In Details</h5>

          <div className="table-responsive mt-2" style={{ overflowX: "auto", ...(stockItems.length >= 4 ? { maxHeight: "280px", overflowY: "auto" } : {}) }}>
            <table className="table table-bordered mb-0" style={{ minWidth: "1570px" }}>
              <thead className="table-light sticky-top" style={{ zIndex: 2 }}>
                <tr>
                  <th style={{ minWidth: "290px" }}>Item Category</th>
                  <th style={{ minWidth: "370px" }}>Item</th>
                  <th style={{ minWidth: "280px" }}>Description</th>
                  <th style={{ minWidth: "100px" }}>UOM</th>
                  <th style={{ minWidth: "140px" }}>Available Quantity</th>
                  <th style={{ minWidth: "130px" }}>Quantity</th>
                  <th style={{ minWidth: "180px" }}>Notes</th>
                  <th style={{ minWidth: "80px" }}>Action</th>
                </tr>
              </thead>
              <tbody>
                {stockItems.map((row, idx) => (
                  <tr key={idx}>
                    <td>

                      <Select
                        value={
                          categories
                            .map((c) => ({
                              value: c.itemCategoryId,
                              label: c.itemCategoryName,
                            }))
                            .find((opt) => String(opt.value) === String(row.itemCategoryId)) || null
                        }
                        onChange={(selected) =>
                          handleCategoryChange(idx, selected ? selected.value : "")
                        }
                        options={getFilteredCategories().map((c) => ({
                          value: c.itemCategoryId,
                          label: c.itemCategoryName,
                        }))}
                        placeholder="Search Category..."
                        isClearable
                        menuPlacement="auto"
                        maxMenuHeight={150}
                        menuPortalTarget={document.body}
                        styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                      />

                    </td>
                    <td>
                      <Select
                        value={
                          getItemOptions(row.itemCategoryId).find(
                            (o) => String(o.value) === String(row.itemId)
                          ) || null
                        }
                        onChange={(selected) =>
                          handleChange(idx, "itemId", selected ? selected.value : "")
                        }
                        options={getItemOptions(row.itemCategoryId)}
                        placeholder="Search Item..."
                        isDisabled={!row.itemCategoryId}
                        isClearable

                        // UI improvements
                        menuPlacement="auto"
                        maxMenuHeight={150}
                        menuPortalTarget={document.body}
                        styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}

                        // remove dropdown arrow (optional same as yours)
                        components={{ DropdownIndicator: null, IndicatorSeparator: null }}
                      />

                    </td>
                    <td>
                      <input
                        type="text"
                        className="form-control"
                        value={row.description || ""}
                        readOnly
                      />
                    </td>
                    <td>
                      {/* UOM is auto-filled from the selected item (readonly) */}
                      <input
                        type="text"
                        className="form-control fw-bold text-dark"
                        value={row.uomId || ""}
                        readOnly
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        className="form-control fw-bold text-dark text-end"
                        value={row.availableQty || "0.000"}
                        readOnly
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        className="form-control fw-bold text-dark text-end"
                        value={row.quantity}
                        onChange={(e) => handleQuantityChange(idx, e)}
                        onBlur={() => handleQuantityBlur(idx)}
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Notes"
                        value={row.notes || ""}
                        onChange={(e) => handleChange(idx, "notes", e.target.value)}
                      />
                    </td>
                    <td>
                      <button
                        type="button"
                        className="btn btn-success btn-sm me-2"
                        onClick={handleAddRow}
                      >
                        +
                      </button>
                      {stockItems.length > 1 && (
                        <button
                          type="button"
                          className="btn btn-danger btn-sm"
                          onClick={() => handleDeleteRow(idx)}
                        >
                          -
                        </button>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="mt-3">
            <button
              type="submit"
              className="btn btn-primary me-2"
              disabled={loading}
            >
              <i className="ti ti-circle-check me-1"></i>
              {loading
                ? isEdit
                  ? "Updating..."
                  : "Saving..."
                : isEdit
                  ? "Update"
                  : "Save"}
            </button>
            <button
              type="button"
              className="btn btn-secondary"
              onClick={handleCancel}
            >
              <i className="ti ti-cancel me-1"></i>
              Cancel
            </button>
          </div>
        </form>
      </div>
    </>
  );
}
